export const ResponseCode = {
  SUCCESS: 200,
};
